import axios from "axios";
import { FileResponse } from "../../types/model/file";
import { SessionStore } from "../../types/store";
import { newAbortSignal } from "../../utils";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/files/metadata`;

export const getFiles = async (
  entityId?: number,
  managementUnitId?: number,
  captureId?: number,
  flowTestId?: number,
): Promise<FileResponse[]> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}",
  );

  let params: Record<string, any> = { entityId };

  if (flowTestId) {
    params.captureId = captureId;
    params.flowTestId = flowTestId;
  } else if (managementUnitId) {
    params.managementUnitId = managementUnitId;
  } else if (captureId) {
    params.captureId = captureId;
  }

  const response = await axios.get<FileResponse[]>(BASE_URL, {
    headers: {
      "Content-Type": "application/json",
      "x-access-token": session?.accessToken,
    },
    params,
    timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
    signal:
      AbortSignal.timeout === undefined
        ? newAbortSignal(Number(process.env.REACT_APP_AXIOS_TIME_OUT))
        : AbortSignal.timeout(Number(process.env.REACT_APP_AXIOS_TIME_OUT)),
  });

  return response.data;
};
